import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { ValuationRequestService } from '../../../shared/services/valuations-request.service';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-view-valuation-requests',
  templateUrl: './view-valuation-requests.component.html',
  styleUrls: ['./view-valuation-requests.component.css']
})
export class ViewValuationRequestsComponent implements OnInit {
  valuationsRequest: any = [];
  isLoading: boolean = false;
  owner: any;
  constructor(private router: Router, private route: ActivatedRoute, private ValuationRequestsService: ValuationRequestService)
   { this.getCurrentAuthenticatedUser();}

  ngOnInit(): void {
    this.getAllValuationRequestsByStatus(this.owner);
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }
 
  getAllValuationRequestsByStatus(status: string) {
    this.isLoading = true;
    
    this.ValuationRequestsService.getAllValuationRequestsByStatus(status).subscribe((data) =>{
      this.isLoading = false;
      console.log("data", data);
      this.valuationsRequest = data;
    }, (error) =>{
      console.log("Error", error);
      this.isLoading = false;
      
    });
  }

  onEditValuationsRequest(sponsor: any){
    console.log("Edit: ", sponsor);
    const queryParams: Params = sponsor;

    this.router.navigate(
      ['/private-space/edit-valuation-request'], 
      {
        relativeTo: this.route,
        queryParams: queryParams, 
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  } 

  onAddValuationsRequest(){
    console.log("Add:");

    this.router.navigate(
      ['/private-space/add-valuation-request']);
  }

  onViewValuationRequest(valuationReq: any) {
    console.log("View: ", valuationReq);
    const queryParams: Params = valuationReq;

    this.router.navigate(
      ['/private-space/view-single-valuation-request'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }


  onDeleteValuationsRequest(valuationReq: any){
    console.log("Delete: ", valuationReq);
    this.isLoading = true;
    this.ValuationRequestsService.deleteValuationRequests(valuationReq).subscribe((data) => {
      this.isLoading = false;
      // this.valuationsRequest = data;
      console.log("Valuations", this.valuationsRequest);
      setTimeout(() => {
        this.getAllValuationRequestsByStatus(this.owner);
        this.isLoading = false;
      }, 2500);
    }, (error) =>{
      setTimeout(() => {
        this.getAllValuationRequestsByStatus(this.owner);
        this.isLoading = false;
      }, 2500);
      console.log("Error: ", error);
 
    })
  }


}
